import * as React from "react";
import {useEffect, useRef, useState} from "react";

import locationsModel from "../shift_shift/locations/locations_model";
import ListOfLocations from "../shift_shift/locations/list_of_locations";

import FilterInput from "../shift_shift/filter_input";
import KeyboardNavigation from "../shift_shift/keyboard_navigation";
import tag_completion from "../tag_completion_on_click";

export type MoveToProps = {
    /**
     * Initial text to set in filter field and to filter by
     */
    filterText?: string;

    /**
     * Collection of task_ids to be moved
     */
    moved_task_ids: string[];

    updateHeightCallback(): void;
};

export const MoveTo = (props: MoveToProps) => {

    const [currentText, setCurrentText] = useState(props.filterText);

    // Need this to re-focus input field on tabs change
    const [focusCounter, updateFocusCounter] = useState(0);

    const [lastModelUpdate, setLastModelUpdate] = useState(null);

    const [selectedIndex, setSelectedIndex] = useState(0);

    // Update window size when search result change
    useEffect(() => {
        props.updateHeightCallback();
    }, [lastModelUpdate])

    const renderedItemsCount = useRef(0);

    const onKeyDown = (e) => {
        const keyboard = new KeyboardNavigation({
            getItemsCount(): number {
                return renderedItemsCount.current;
            }, getSelectedIndex(): number {
                return selectedIndex;
            }, setSelectedIndex(idx: number): void {
                setSelectedIndex(idx);
            },
            onLeft() {
                let selectionId = locationsModel.backState();
                if (selectionId >= 0) {
                    setSelectedIndex(selectionId);
                }
            },
            onRight() { locationsModel.forwardState(); }
        });

        keyboard.onKeyDown(e);
    };

    const saveStateForFuture = (text) => {
        maxkir.set_flag("last_search_txt_mm", text, 3600);
    };

    const onFilterTextChanged = (text, memorizeValue) => {
        setCurrentText(text);
        locationsModel.onTextChanged(text, true);
        if (memorizeValue || !text) {
            saveStateForFuture(text);
        }
    }

    const saveStateAndClosePopups = (saveFilterText: boolean) => {
        saveStateForFuture(saveFilterText ? currentText : null);
        maxkir.cmd && maxkir.cmd.close_all_popups();
    }

    useEffect(() => {
        const modelUpdated = () => {
            setLastModelUpdate(new Date()); // To trigger UI refresh

            if (locationsModel.shouldResetSelection()) {
                setSelectedIndex(0);
            }

            // The model can change the filter text in the field
            setCurrentText(locationsModel.getFilterTerms().join(" "));
        }

        locationsModel.addDataAvailableCallback(modelUpdated);
        locationsModel.onTextChanged(currentText || "", false); // Initial filtering with explicit text if needed

        return () => {
            locationsModel.removeDataAvailableCallback(modelUpdated);
        }
    }, [])


    const tagCompletionOnClick = (event) => {
        tag_completion(event, currentText, (newText) => {
            onFilterTextChanged(newText, false);
            // To focus input element:
            updateFocusCounter(focusCounter + 1);
        })
    }

    const locationsActionCallback = (list_id: number, task_id: number, filterText: string, el: HTMLElement, event?: Event) => {
        if (!list_id) {
            list_id = maxkir.Task.checklist_id(task_id);
        }

        let navigate_to = false;
        if (event instanceof MouseEvent || event instanceof KeyboardEvent) {
            navigate_to = (event.ctrlKey || event.metaKey) && event.shiftKey;
        }
        maxkir.CopyPaste.move_to_list(list_id, props.moved_task_ids, task_id, navigate_to)
    }


    const styles = { "--searchEverywhere-maxHeight": "350px"} as React.CSSProperties;

    return <div className="searchEverywhere searchEverywhere__moveTo" style={styles} tabIndex={-1} onKeyDown={onKeyDown}
                onClick={tagCompletionOnClick}>

            <p className={'intro inMenu'}
               dangerouslySetInnerHTML={{__html: I18N('move_dialog_title')}}></p>

            <FilterInput filterText={currentText} onTextChanged={onFilterTextChanged} setFocus={focusCounter}
                         placeholder={I18N('js_move_dialog_filter_placeholder')}
                         isChanged={currentText !== props.filterText}
                         inProgress={locationsModel.isLoading()}
            />
            <ListOfLocations
                model={locationsModel}

                onBeforeItemOpen={saveStateAndClosePopups}
                actionCallback={locationsActionCallback}

                selectedIndex={selectedIndex}

                renderedItemsCountCallback={(x) => {
                    renderedItemsCount.current = x;
                }}
                isActiveTab={true}
            />
        <div className={"searchEverywhere__footer"}><span>Press <kbd>Enter</kbd><span> to move  </span>
            <kbd>{maxkir.MAC ? "Cmd" : "Ctrl"} Shift Enter</kbd> to navigate to the target location</span></div>
    </div>
}


/**
 *      this.completer = maxkir.DataCompleter.create_completer(this.popupFilter(), {
 *         existing_tags_provider: null,
 *         list_content_editing: true
 *       });
 */